import React, { PureComponent } from "react";
import styles from "./animation.module.scss";

class Animation extends PureComponent {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    const { hasText } = this.props;

    if (hasText) {
      this.stroke();
    } else {
      this.particle();
    }
  }

  componentDidUpdate() {
    const { hasText } = this.props;

    if (hasText) {
      this.stroke();
    } else {
      this.particle();
    }
  }

  stroke = () => {
    const { hasText } = this.props;
    const canvas = this.canvasRef.current;
    const context = canvas.getContext("2d");

    // Fit Canvas to window
    context.canvas.width = window.innerWidth;
    context.canvas.height = window.innerHeight;

    // initialize();

    // function initialize() {
    //   //Event listener to call the resizeCanvas() function
    //   window.addEventListener('resize', resizeCanvas, false);
    //   // Draw canvas border for the first time.
    //   resizeCanvas();
    // }

    // // Resets the canvas dimensions to match window,
    // function resizeCanvas() {
    //   context.canvas.width = window.innerWidth;clear
    //   context.canvas.height = window.innerHeight;
    //   // requestAnimationFrame(loop);
    // }

    let dashLen = 220;
    let dashOffset = dashLen;
    let speed = 5;

    const txt = hasText;

    const y = 50;
    let x = 490;
    let i = 0;

    context.font = "40px Comic Sans MS, cursive, TSCu_Comic, sans-serif";
    context.lineWidth = 4;
    context.lineJoin = "round";
    context.globalAlpha = 2 / 3;
    context.direction = "ltr";
    context.textBaseline = "alphabetic";
    context.strokeStyle = "#ffffff";
    context.fillStyle = "#ffffff";
    // context.translate(x, txtLocation);

    function loop() {
      //Clear the canvas
      // context.fillStyle = "hsla(0, 0%, 0%, 0)";
      context.save();
      context.beginPath();

      context.clearRect(x, y, canvas.width, canvas.height);
      context.setLineDash([dashLen - dashOffset, dashOffset - speed]); // create a long dash mask
      dashOffset -= speed; // reduce dash length

      context.strokeText(txt[i], x, y); // stroke letter

      if (dashOffset > 0) {
        requestAnimationFrame(loop); // animate
      } else {
        context.strokeText(txt[i], x, y); // fill final letter

        dashOffset = dashLen; // prep next char
        x +=
          context.measureText(txt[i++]).width +
          context.lineWidth * Math.random();
        context.setTransform(1, 0, 0, 1, 0, 3 * Math.random()); // random y-delta
        context.rotate(Math.random() * 0.005); // random rotation

        context.closePath();
        context.fill();

        if (i < txt.length) {
          requestAnimationFrame(loop);
        }
      }
      // requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
  };

  particle = () => {
    //const { x, y } = this.props; //radius, opacity
    const canvas = this.canvasRef.current;
    const context = canvas.getContext("2d");

    var particleIndex = 0;
    var particles = {};
    var particleNumber = 2;
    /*var prticleSizeW = 5;*/
    /*var particleSizeH = 5;*/

    // Fit Canvas to window
    context.canvas.width = window.innerWidth;
    context.canvas.height = window.innerHeight;

    // handle window resize
    initialize();

    function initialize() {
      // Event listener to call the resizeCanvas() function
      window.addEventListener("resize", resizeCanvas, false);
      // Draw canvas border for the first time.
      resizeCanvas();
    }
    // Resets the canvas dimensions to match window,
    function resizeCanvas() {
      context.canvas.width = window.innerWidth;
      context.canvas.height = window.innerHeight;
    }

    //Clear the canvas
    context.fillStyle = "hsla(0, 0%, 0%, 0)";
    //context.fillRect(0, 0, canvas.width, canvas.height);
    context.clearRect(0, 0, canvas.width, canvas.height);

    //Create a particle object
    function Particle() {
      // Particle attibutes/blueprint
      this.parX = canvas.width * Math.random();
      this.parY = canvas.height * Math.random();

      // Velocity
      this.velX = Math.random() * 20 - 10;
      this.velY = Math.random() * 20 - 10;

      // Gravity effect
      this.gravity = 0.3;

      // Assign id to each particle
      particleIndex++;
      particles[particleIndex] = this;
      this.id = particleIndex;

      // Particle onscreen lifetime
      this.life = 0;
      this.maxLife = 2 //  Math.random() * 200 - 10;

      // Return a Particle object
      return this;
    }

    // draw the particle
    Particle.prototype.draw = function () {
      this.parX += this.velX;
      this.parY += this.velY;
      if (Math.random() < 0.1) {
        this.velX = Math.random() * 10 - 5;
        this.velY = Math.random() * 10 - 5;
      }

      // This is where to play with particle gravity effect
      this.velX += this.gravity;
      this.velY += this.gravity;

      // Handle total life for each particle drawn
      this.life++;
      if (this.life >= this.maxLife) {
        delete particles[this.id];
      }

      context.save();
      context.beginPath();

      // Colour Styling of Particles
      context.fillStyle = "hsla(147, 50%, 47%, 0.5)"; // "hsla(" + (Math.random() * 360, 5) + ", 100%, 50%, 0.2)"; //

      // Location to draw Particles and the size of the particle
      context.arc(
        this.parX,
        this.parY,
        Math.random() * (10 - 5) + 1,
        0,
        Math.PI * 2,
        true
      );

      // Global transparency added to all particles used when not controlled by hsla
      /*context.globalAlpha = Math.random() * 10 - 5;*/

      context.closePath();
      context.fill();

      // Square Particles
      /*context.fillRect(this.parX, this.parY, prticleSizeW, particleSizeH); prticleSizeW */
    };;

    // Controls the speed in miliseconds at which the particles are draw.
    setInterval(() => {
      //globalCompositeOperation https://www.w3schools.com/tags/canvas_globalcompositeoperation.asp
      context.globalCompositeOperation = "source-over";

      for (var i = 0; i < particleNumber; i++) {
        new Particle();
      }
      context.globalCompositeOperation = "lighter";
      for (var x in particles) {
        particles[x].draw();
      }
    }, 150);
  };

  /*onMouseMove={this.props.handleMouseEvent} onMouseOut={this._onMouseOut}
   * <div className="overlay">THIS IS OVER THE TOP OF THE CANVAS</div>*/
  render() {
    return (
      <div className={styles.canvasContainer}>
        <canvas ref={this.canvasRef} id="canvas"></canvas>
      </div>
    );
  }
}

export default Animation;
